import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {
  methods: {
    //获取单条数据
    GetByBabyId(BabyId) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        BabyId: BabyId,
      };
      this.loading = true;
      $http.get("api/Baby/GetByBabyId", params).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.form = Data
          this.BabyInfo = cloneDeep(this.form.BabyInfo)
          this.CourseInfo = cloneDeep(this.form.CourseInfo)
          this.NetWorkCheckList = cloneDeep(this.form.NetWorkCheckList)

          this.BabyParentList = cloneDeep(this.form.BabyParentList)
          this.BabyOrderList = cloneDeep(this.form.BabyOrderList)
          if (this.form.SchoolInfo) {
            this.SchoolInfo = cloneDeep(this.form.SchoolInfo)
            this.ClassInfo = cloneDeep(this.form.ClassInfo)
            this.BabyAgentInfo = cloneDeep(this.form.BabyAgentInfo)
          }
          if (this.form.FollowList) {
            this.FollowList = cloneDeep(this.form.FollowList)
          }
        });
      });
    },

  }
}


// WEBPACK FOOTER //
// ./src/pages/Family/StudentsList/viewDialog/services.js